import { UsuarioService } from './../usuario/usuario.service';
import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Login } from '../../model/login';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../../environments/environment';
import { AutenticacaoCustom } from '../../model/autenticacaoCustom';

@Injectable()
export class LoginService {

    data: any = null;
    jwtHelperService: JwtHelperService = new JwtHelperService();
    roles: string;
    rolesArray: string[];
    public newLoginEmitter: EventEmitter<any> = new EventEmitter();

    constructor(private http: HttpClient, private router: Router, private usuarioService: UsuarioService) {
    }

    useJwtHelper() {
        var token = localStorage.getItem('token');

        console.log(
            this.jwtHelperService.decodeToken(token),
            this.jwtHelperService.getTokenExpirationDate(token),
            this.jwtHelperService.isTokenExpired(token)
        );
    }

    private loggedIn: boolean = false;

    get isLoggedIn(): boolean {
        var token = localStorage.getItem('token');
        var isOk = false;

        if (token != null) {
            if (this.jwtHelperService.decodeToken(token).hasOwnProperty('iss')) {
                var jwtIssuer = this.jwtHelperService.decodeToken(token).iss;
                isOk = ((jwtIssuer.indexOf('Manager') !== -1) && (!this.jwtHelperService.isTokenExpired(token)));
            } else {
                console.error('JWT nao possui atributo iss.');
            }
        }
        return isOk;
    }

    private armazenaDadosLogin(loginResponse) {
        this.loggedIn = false;

        let token = loginResponse && loginResponse.token;
        if (token) {
            localStorage.setItem('currentUser', JSON.stringify(loginResponse));
            localStorage.setItem('token', token);
            localStorage.setItem('isVarejo', loginResponse.varejo);
            this.loggedIn = true;
            this.newLoginEmitter.emit(loginResponse);
        }
    }

    //rearmazenaDadosLogin is same as armazenaDadosLogin though asserting if token exists
    private rearmazenaDadosLogin(loginResponse) {
        let oldToken = localStorage.getItem('token');
        if (oldToken) {
            this.armazenaDadosLogin(loginResponse);
        }
    }

    doLogin(usr: Login): Promise<any> {
        return this.http
            .post(environment.backendBaseUrl + '/manager/usuarios/login/usrsenha', usr)
            .toPromise()
            .then(res => {
                this.armazenaDadosLogin(res);
                this.redirect(res);
            })
            .catch(this.handleError);
    }

    reloginSePertoDeExpirar() {
        const login = JSON.parse(localStorage.getItem('currentUser'));
        if (!login) {
            return;
        }

        const expDate = new Date(login.dataExpiracao * 1000);
        const agora = new Date();

        const diferencaMinutos = (expDate.getTime() - agora.getTime()) / 1000 / 60

        if (diferencaMinutos > 0 && diferencaMinutos <= 5) {
            const idUsuario = login.id;
            AutenticacaoCustom.setAutenticacaoCustom(`${localStorage.getItem('token')}`);
            return this.http
                .post(`${environment.backendBaseUrl}/manager/usuarios/${idUsuario}/login/reanimacao`, login)
                .toPromise()
                .then(res => this.rearmazenaDadosLogin(res))
                .catch(this.handleError);
        }
    }

    logout() {
        this.loggedIn = false;
        const login = JSON.parse(localStorage.getItem('currentUser'));

        if (login !== null) {
            this.usuarioService.registrarLoginRemovido(login.id, login.organizacaoId, login).subscribe(
                res => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('currentUser');
                    this.router.navigate(['/login']);
                },
                err => {
                    localStorage.setItem('errMessage', err.message);
                    localStorage.removeItem('token');
                    localStorage.removeItem('currentUser');
                    this.router.navigate(['/login']);
                }
            );
        } else {
            localStorage.removeItem('token');
            localStorage.removeItem('currentUser');
            this.router.navigate(['/login']);
        }        
    }

    private handleError(error: any): Promise<any> {
        if (error.statusText === 'Unknown Error') {
            alert("Sistema indisponível.");
        } else {
            alert(error.error.message);
        }

        console.error('OCORREU UM ERRO:', error.error.message);
        return Promise.reject(error.error.message || error);
    }

    redirect(loginResponse) {
        let token = loginResponse && loginResponse.token;
      
        if (token) {
            let jwt = this.jwtHelperService.decodeToken(token);
            let roles = jwt.roles.split("|");
            
            let isGestor = roles.indexOf("GESTOR") >= 0;

            if (isGestor) {
                this.loggedIn && this.router.navigate(['/relatorios'])
             } else {
                this.loggedIn && this.router.navigate(['/carteira-certificado'])
             }
        }
    }

    getRoles(): string[] {
        if (localStorage.getItem("token")) {
            let jwt = this.jwtHelperService.decodeToken(localStorage.getItem("token"));
            this.roles = jwt.roles;
            this.rolesArray = this.roles.split("|");     
        }
        return this.rolesArray;
    }
}
